import React from 'react';
import { ArrowRight, ShieldCheck, TrendingUp } from 'lucide-react';

const RANKS = [
  { k: 'Google', v: '#1' },
  { k: 'ChatGPT', v: 'Cited' },
  { k: 'AI Overviews', v: 'Cited' },
  { k: 'Perplexity', v: 'Cited' },
];

export default function RankrHero() {
  return (
    <section className="relative bg-[#0B0B0B] pt-32 lg:pt-40 pb-16 lg:pb-24 overflow-hidden">
      <div className="absolute inset-0 fine-grid opacity-25" />
      <div className="absolute top-0 right-0 w-2/3 h-full bg-[radial-gradient(circle_at_top_right,rgba(37,99,235,0.20),transparent_60%)]" />
      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10 grid lg:grid-cols-[1.15fr_1fr] gap-14 items-center">
        <div>
          <div className="inline-flex items-center gap-2.5 mb-7 px-4 py-2 rounded-lg border border-[#3B82F6]/30 bg-[#2563EB]/10">
            <TrendingUp className="w-3.5 h-3.5 text-[#3B82F6]" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/80">Rankr · SEO, done for you</span>
          </div>
          <h1 className="font-display font-bold text-white tracking-tight leading-[1.05]" style={{ fontSize: 'clamp(2.3rem, 4.8vw, 4.2rem)' }}>
            Show up #1 on Google<br />
            <span className="text-[#3B82F6]">and ChatGPT.</span>
          </h1>
          <p className="mt-7 text-white/60 text-base lg:text-lg leading-relaxed font-light max-w-xl">
            Rankr learns your business, finds what your customers are searching for and publishes helpful content to your site every day. Our engineers set it up and run it for you, so your business grows while you sleep.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a href="#rankr-pricing" className="group inline-flex items-center justify-center gap-2 px-8 h-14 rounded-lg text-sm font-semibold bg-[#2563EB] text-white hover:bg-[#1D4ED8] transition-colors blue-glow">
              See Pricing <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="#rankr-start" className="inline-flex items-center justify-center px-8 h-14 rounded-lg text-sm font-semibold border border-white/20 text-white hover:border-white/50 transition-colors">
              Talk to an Engineer
            </a>
          </div>
          <p className="mt-6 flex items-center gap-2 text-xs text-white/45">
            <ShieldCheck className="w-4 h-4 text-[#3B82F6]" /> Iron-clad 90-day money-back guarantee.
          </p>
        </div>
        <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-7 lg:p-8">
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#3B82F6] mb-6">yourbusiness.com · Visibility</p>
          {RANKS.map((r) => (
            <div key={r.k} className="flex items-center justify-between py-4 border-b border-white/10 last:border-0">
              <span className="text-white/70 text-sm">{r.k}</span>
              <span className="font-display font-bold text-white text-xl">{r.v}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}